import React from 'react';
import _ from 'lodash';
import withUpload from "../../hoc/withUpload";
import {Button} from "../Button";

class Uploader extends React.Component {
    constructor(props){
        super(props);
        this.id = _.random(0, 99999);
        this.state = {
            errorMessage: '',
            preview: this.props.preview,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.preview !== this.props.preview){
            this.setState({preview: this.props.preview});
        }
    }

    onUploadError({response}){
        this.props.reset();
        let message = '';
        switch (response.statusCode) {
            case 413:
                message = `Fichier trop lourd, maximum accepté : ${response.errors.maxFileSizeStr}`;
                break;
            case 415:
                message = `Fichier non accepté, sont acceptés : ${response.errors.allowedTypes.join(', ')}`;
                break;
            default :
                message = 'Envoi du fichier impossible, erreur système inconnue';
                break;
        }
        this.setState({errorMessage: message, preview: ""})
    }

    onUploadSuccess(data){
        this.props.getUploadData && this.props.getUploadData(data, this.state.preview);
        this.props.reset();
        this.props.handleClose();
    }

    render(){
        return <div id={"uploads"} className={"modal-container"}>
            <div className={"modal-topline"}>
                {`Télécharger une photo`}
            </div>
            <div className={"modal-body"}>
                {this.props.preview &&
                    <div className={"img-preview-container"}>
                        <img alt={""} className={`img-preview`} src={this.props.preview} />
                    </div>
                }
                <input type="file"
                       id={this.id}
                       key={this.props.loadedFile.name}
                       style={{display:'none'}}
                       accept="image/jpeg, image/png, image/gif"
                       disabled={this.props.uploading}
                       onChange={this.props.loadFile.bind(this)}/>

                <label htmlFor={this.id} className={"upload-input-btn"}>
                    <div className="btn white"
                        style={{background: `linear-gradient(to right,#51a9fd ${this.props.uploadProgress.percentCompleted}%,#1F7DEC ${this.props.uploadProgress.percentCompleted}%)`}}
                    >
                        {this.props.uploading ? (
                            `Envoi... ${Math.round(this.props.uploadProgress.eta / 1000)}s (${this.props.uploadProgress.kos}ko/s)`
                        ) : (
                            _.truncate(this.props.loadedFile.name, {length:this.props.nameLength || 25}) || 'Choisissez un fichier'
                        )}
                    </div>
                </label>
            </div>
            <div className={"modal-baseline"}>
                {this.state.errorMessage && <span className={"warning upload-error-message"}>{this.state.errorMessage}</span>}
                {!this.props.uploading &&
                    <Button btnStyle={"grey"}
                            size={"small"}
                            onClick={()=>this.props.handleClose()}
                            content={"Fermer"}/>
                }
                {this.props.loadedFile.name && (
                    this.props.uploading ?
                        <Button btnStyle={"cancel-reverse"}
                                size={"small"}
                                onClick={()=>this.props.reset()}
                                content={"Annuler"}/>
                        :
                        <Button btnStyle={"primary-reverse"}
                                size={"small"}
                                onClick={()=>this.props.uploadFile()}
                                content={"Envoyer"}/>
                )}
            </div>
        </div>
    }
}

export default withUpload(Uploader);